import React, { Fragment } from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { EmptySearchResultsTypes } from '../../../../types/index';
import GetFreeQuotes from './GetFreeQuotes';
import ErrorImage from './images/empty-search-results.png';
import './index.scss';

const EmptySearchResults = ({ displayData }) => {

    const { searchComponentData: { query, isInBlackList }, currentUser: { username } } = displayData;
    const messageText = `search_perseus.error_page.empty_search_results.${isInBlackList ? 'blocked' : 'valid'}`;

    return (
        <div className={classNames('error-page', 'max-width-container', 'empty-search-results')}>
            <div className="error-image">
                <img src={ErrorImage} alt="empty result image"/>
                <small><I18n k={'search_perseus.error_page.made_on_fiverr'} parseMarkup/> <b>onekaa</b></small>
            </div>
            <h2>
                <I18n k={`${messageText}.header`}/>
            </h2>
            <p><I18n k={`${messageText}.quotes_explain`}/></p>
            <GetFreeQuotes username={username} isInBlackList={isInBlackList}/>
            {!isInBlackList &&
                <Fragment>
                    <div className="or-in-line">
                        <p><I18n k={'search_perseus.error_page.empty_search_results.or'}/></p>
                    </div>
                    <UserNameSearch query={query}/>
                </Fragment>
            }
        </div>
    );
};

const UserNameSearch = ({ query }) => {
    const userSearchURL = pathfinder('search_users', null, { query: { query, search_in: 'everywhere', source: 'no-results' } });

    return (
        <a href={userSearchURL} className="username-search">
            <span className="fa-stack">
                <i className="fa fa-user fa-stack-1x"/>
                <i className="fa fa-search fa-stack-1x"/>
            </span>
            <I18n k={'search_perseus.error_page.empty_search_results.username_search'} params={{ search_term: query }}/>
        </a>);
};

EmptySearchResults.propTypes = EmptySearchResultsTypes;

EmptySearchResults.defaultProps = {
    searchComponentData: {
        isInBlackList: false
    }
};

export default EmptySearchResults;
